import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="slide-over"
export default class extends Controller {
  static targets = ["createForm"]

  connect() {
    document.body.classList.add("overflow-hidden")
    this.element.focus()
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  close() {
    this.element.remove()
  }

  toggleCreateForm(event) {
    const beerForm = document.getElementById("create_beer_form")
    const mainActions = document.getElementById("main_form_actions")

    if (beerForm) beerForm.classList.add("hidden")
    const formToShow = beerForm

    if (formToShow) {
      formToShow.classList.remove("hidden")

      if (mainActions) {
        mainActions.classList.add("hidden")
      }

      const firstInput = formToShow.querySelector("input[type='text']")
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 100)
      }
    }
  }
  
  closeCreateForm() {
    const beerForm = document.getElementById("create_beer_form")
    const mainActions = document.getElementById("main_form_actions")

    if (beerForm) beerForm.classList.add("hidden")
    if (mainActions) mainActions.classList.remove("hidden")
  }
} 
